import Component from './decorated-header';
export default Component;
